<template>
    <div class="iq-sidebar  sidebar-default ">
        <div class="iq-sidebar-logo d-flex align-items-center justify-content-between">
            <a  href="/" class="header-logo">
                <img src="/assets/images/yeleDash.png" class="img-fluid rounded-normal light-logo" alt="logo"><h5 class="logo-title light-logo ">ADMIN</h5>
            </a>
            <div class="iq-menu-bt-sidebar ml-4">
                <i class="fa fa-bars wrapper-menu"></i>
            </div>
        </div>
        <div class="scroller data-scrollbar" data-scroll="3">
            <nav class="iq-sidebar-menu">
                <ul id="iq-sidebar-toggle" class="iq-menu">
                    <li class="active">
                        <a href="/" class="svg-icon">                        
                            <svg  class="svg-icon" id="p-dash1" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                            </svg>
                            <span class="ml-4">Accueil</span>
                        </a>
                    </li>
                    <li class="" v-if="store.state.user.is_admin && store.state.user.entreprise_id == null" >
                        <router-link to="/index-entreprises" class="collapsed" data-toggle="collapse" aria-expanded="">
                            <svg class="svg-icon" id="p-dash8" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span class="ml-4">Entreprises</span>
                            
                        </router-link>
                    </li>
                    <li class="" v-if="store.state.user.is_admin && store.state.user.entreprise_id == null">
                        <router-link to="/index-users" class="collapsed" data-toggle="collapse" aria-expanded="">
                            <svg class="svg-icon" id="p-dash8" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span class="ml-4">Utilisateurs</span>
                            
                        </router-link>
                    </li>
                    <li class="" >
                        <router-link to="/index-client" class="collapsed" data-toggle="collapse" aria-expanded="">
                            <svg class="svg-icon" id="p-dash8" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span class="ml-4">Client</span>
                            
                        </router-link>
                    </li>
                    <li class="" >
                        <router-link to="/report" class="collapsed" data-toggle="collapse" aria-expanded="">
                            <svg class="svg-icon" id="p-dash8" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span class="ml-4">Rapport</span>
                        </router-link>
                    </li>
                </ul>
            </nav>
            <div class="p-3"></div>
        </div>
    </div>
</template>
<script>
import store from '@/store'
import axios from 'axios'
import Swal from 'sweetalert2'

import {URL_AUTH_API} from '@/config'
export default {
    mounted(){
        this.getusers()
    },
    data() {
        return {
            permissions: [],
            store: store,
            active: null
        };
    },
    methods:{
        getusers() {
            console.log('user',this.store.state.user)
            this.isLoading =  true
            axios.get(URL_AUTH_API+'user')
            .then(response => {
                console.log('connected',response)
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                this.isLoading =  false
                localStorage.removeItem('token')
                localStorage.removeItem('token_api')
                localStorage.setItem('user',null)
                Swal.fire({
                    icon: 'error',
                    title: 'Deconnexion',
                    text: 'Session expiré!',
                    showConfirmButton: false,
                    timer: 5000
                }) 
                window.location.href = '/connexion';
            })
        },
    }
}
</script>